import React from "react";
import PropTypes from "prop-types";
import Drawer from "@material-ui/core/Drawer";
import AddEditForm from "./add-edit-form";

const NoClient = ({ open, currency, canEdit, close, tercero, society, division }) => {
  return (
    <div>
      {open && (
        <Drawer className="sidebar-container" open={open} variant="persistent" anchor="right">
          <AddEditForm
            currency={currency}
            close={close}
            canEdit={canEdit}
            sapCode={tercero}
            society={society}
            division={division}
          />
        </Drawer>
      )}
      {open && <div className="sidebar-back fade show" />}
    </div>
  );
};
NoClient.propTypes = {
  open: PropTypes.bool,
  currency: PropTypes.string,
  canEdit: PropTypes.bool,
  close: PropTypes.func,
  tercero: PropTypes.string,
  society: PropTypes.string,
  division: PropTypes.string
};

NoClient.defaultProps = {
  open: false,
  currency: "EUR",
  canEdit: true,
  close: () => {},
  tercero: "",
  society: "",
  division: ""
};

export default NoClient;
